module.exports = __webpack_public_path__ + "img/form_top.8820231b.png";